// Mirrors the server's price list - the server always decides the real amount
export const VISIT_FEES = { initial: 300, follow_up: 150, follow_up_phone: 125 };
export const VISIT_KEYS = {
  initial: "initial_consultation_gbp", follow_up: "follow_up_consultation_gbp",
  follow_up_phone: "follow_up_telephone_gbp", tests_only: "tests_only",
};
export const VISIT_NAMES = { initial: "New consultation", follow_up: "Follow-up consultation (in person)", follow_up_phone: "Telephone follow-up" };

export const TESTS = {
  "ambulatory-bp-monitoring": { label: "Ambulatory BP monitoring (24 hours)", price: 380, standalone: true },
  ecg: { label: "ECG (electrocardiogram)", price: 150, standalone: false },
  "holter-monitoring": { label: "Ambulatory ECG (Holter)", price: 380, standalone: false, perDay: true },
  echocardiography: { label: "Echocardiogram", price: 350, standalone: true },
  bioimpedance: { label: "Bioimpedance body composition", price: 100, standalone: false },
};

export const testsIn = (reasons) => Object.keys(TESTS).filter((t) => reasons.includes(t));

/** What the patient is booking: visit type, tests, and the line items that make up the total. */
export const HOLTER = "holter-monitoring";
export const HOLTER_PRICES = { 1: 380, 2: 450, 3: 495, 5: 595, 7: 695, 10: 825, 14: 950 };
const testLine = (t, days) => (t === HOLTER
  ? { label: `Ambulatory ECG (Holter, ${days} day${days > 1 ? "s" : ""})`, price: HOLTER_PRICES[days] || HOLTER_PRICES[1] }
  : { label: TESTS[t].label, price: TESTS[t].price });

export const planVisit = (reasons, visit = "initial", holterDays = 1, testsOnlyChoice = true) => {
  const tests = visit === "follow_up_phone" ? [] : testsIn(reasons);
  const testsOnly = testsOnlyChoice && visit === "initial" && tests.length > 0 && tests.length === reasons.length && tests.every((t) => TESTS[t].standalone);
  const kind = testsOnly ? "tests_only" : visit;
  const lines = [...(testsOnly ? [] : [{ label: `${VISIT_NAMES[visit]} · ${visit === "initial" ? "1 hour" : "30 minutes"}`, price: VISIT_FEES[visit] }]), ...tests.map((t) => testLine(t, holterDays))];
  return { kind, tests, testsOnly, lines, total: lines.reduce((a, l) => a + l.price, 0), lookupKey: VISIT_KEYS[kind], holterDays: tests.includes(HOLTER) ? holterDays : 1 };
};
